import Phaser from 'phaser';

// Блокирующий overlay для портретной ориентации. Active с момента старта игры,
// рендерится поверх всех остальных сцен (последняя в scene array → top depth).
// При portrait → видим + пауза GameScene. При landscape → невидим + resume.
// Десктопа фактически не касается (там width > height всегда, кроме узких окон).
//
// Альтернатива через CSS (был в index.html) убрана — Phaser-сцена ловит pause/resume
// для активной игры, чего DOM-overlay не умеет.
export class PortraitOverlayScene extends Phaser.Scene {
  private bg!: Phaser.GameObjects.Rectangle;
  private icon!: Phaser.GameObjects.Text;
  private title!: Phaser.GameObjects.Text;
  private hint!: Phaser.GameObjects.Text;
  // Запомненный последний статус — чтобы не дёргать pause/resume каждый resize.
  private wasPortrait = false;

  constructor() {
    super({ key: 'PortraitOverlay', active: true });
  }

  create(): void {
    const { width, height } = this.scale;

    this.bg = this.add
      .rectangle(0, 0, width, height, 0x0a0a0a, 0.95)
      .setOrigin(0, 0)
      .setDepth(1000)
      .setScrollFactor(0)
      // Перехватывает тачи — иначе во время паузы пальцы доходят до canvas под overlay.
      .setInteractive();

    this.icon = this.add
      .text(width / 2, height / 2 - 80, '📱', { fontSize: '72px' })
      .setOrigin(0.5)
      .setDepth(1001)
      .setScrollFactor(0);

    this.title = this.add
      .text(width / 2, height / 2, 'Поверни телефон', {
        fontFamily: 'Arial',
        fontSize: '24px',
        color: '#ffffff',
        fontStyle: 'bold',
        align: 'center',
      })
      .setOrigin(0.5)
      .setDepth(1001)
      .setScrollFactor(0);

    this.hint = this.add
      .text(width / 2, height / 2 + 40, 'в горизонтальное положение', {
        fontFamily: 'Arial',
        fontSize: '16px',
        color: '#aaaaaa',
        align: 'center',
      })
      .setOrigin(0.5)
      .setDepth(1001)
      .setScrollFactor(0);

    this.updateVisibility();
    this.scale.on('resize', this.handleResize, this);
    this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
      this.scale.off('resize', this.handleResize, this);
    });
  }

  private handleResize(): void {
    const { width, height } = this.scale;
    this.bg.setSize(width, height);
    this.icon.setPosition(width / 2, height / 2 - 80);
    this.title.setPosition(width / 2, height / 2);
    this.hint.setPosition(width / 2, height / 2 + 40);
    this.updateVisibility();
  }

  private updateVisibility(): void {
    const isPortrait = this.scale.height > this.scale.width;
    this.bg.setVisible(isPortrait);
    this.icon.setVisible(isPortrait);
    this.title.setVisible(isPortrait);
    this.hint.setVisible(isPortrait);
    // Включаем/отключаем перехват тачей вместе с видимостью — иначе невидимый bg
    // продолжал бы блокировать клики по игре в landscape.
    if (isPortrait) this.bg.setInteractive();
    else this.bg.disableInteractive();

    if (isPortrait !== this.wasPortrait) {
      this.wasPortrait = isPortrait;
      // Пауза/resume только активной GameScene. Menu/Map/Boot не паузим — реального
      // времени там нет, дополнительная сложность не нужна.
      const game = this.scene.get('GameScene');
      if (game && this.scene.isActive('GameScene')) {
        if (isPortrait) this.scene.pause('GameScene');
        else this.scene.resume('GameScene');
      }
    }
  }
}
